var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 41,
    viewBox: "0 0 155 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.728001V39.928H22.064V32.032H8.4V0.728001H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0268 20.328C64.0268 9.016 54.9548 0 43.5308 0C32.1068 0 23.0348 9.016 23.0348 20.328C23.0348 31.64 32.1068 40.656 43.5308 40.656C54.9548 40.656 64.0268 31.64 64.0268 20.328ZM55.4028 20.328C55.4028 27.104 50.1948 32.48 43.5308 32.48C36.8668 32.48 31.6588 27.104 31.6588 20.328C31.6588 13.552 36.8668 8.176 43.5308 8.176C50.1948 8.176 55.4028 13.552 55.4028 20.328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.11 10.136C103.918 3.808 97.3096 0 89.4136 0C78.1576 0 68.9176 9.128 68.9176 20.328C68.9176 31.528 77.9336 40.656 89.3576 40.656C100.558 40.656 108.734 32.256 108.734 21.28V18.144H88.3496V25.2H99.7176C98.6536 29.68 94.6216 32.76 89.4136 32.76C82.6936 32.76 77.4296 27.216 77.4296 20.328C77.4296 13.384 82.6936 7.952 89.3576 7.952C93.8936 7.952 97.5336 10.024 99.4936 13.832L107.11 10.136Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.261 20.328C154.261 9.016 145.189 0 133.765 0C122.341 0 113.269 9.016 113.269 20.328C113.269 31.64 122.341 40.656 133.765 40.656C145.189 40.656 154.261 31.64 154.261 20.328ZM145.637 20.328C145.637 27.104 140.429 32.48 133.765 32.48C127.101 32.48 121.893 27.104 121.893 20.328C121.893 13.552 127.101 8.176 133.765 8.176C140.429 8.176 145.637 13.552 145.637 20.328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eaf3c0bc058e0ed6471ba20dc0af6da2.svg";
export { ForwardRef as ReactComponent };